import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/OrangeQontact.svg';
import designSystemStyles from '@shared/styles/designSystemStyles';

export const OrangeQontactLogo: React.FC = () => {
    return (
        <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
        }}>
            <QontactTextSVG
                style={{ 
                    height: '100%',
                    width: 'auto',
                    fill: designSystemStyles.colorMainAction,
                    marginLeft: '-3px'
                }}
            />
        </div>
    )
}